import React, {useState} from 'react';

const ListItemNoDiscount = ({ item, displayDiscount, subscription, selected, handleCheck }) => {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 2
    });

  return (
                  <tr>
                      <th scope="row">
                          <div className="d-flex align-items-center">
                              <input
                                  className="form-check-input m-0 me-3 border-secondary shadow-sm"
                                  style={{ cursor: 'pointer', width: '1.25em', height: '1.25em' }}
                                  type="radio"
                                  name="itemSelection"
                                  checked={selected}
                                  onChange={() => handleCheck(item, subscription)}
                              />
                              <span className="fw-bold" style={{ cursor: 'pointer' }} onClick={() => handleCheck(item, subscription)}>
                                  {item.clientName}
                              </span>
                          </div>
                      </th>
                      <td>{subscription.subscriptionName}</td>
                      <td>{currencyFormatter.format(subscription.price)}</td>
                      <td>{item.subTax}%</td>
                      {
                          displayDiscount && (
                              <td>N/A</td>
                          )
                      }
                  </tr>
  );
}

export default ListItemNoDiscount;